<!-- Business Status -->
<template>
  <div class="bsList-page">
    <!-- 상단 헤더 -->
    <header class="header">
      <div class="header-left">
        <span>NO.</span>
        <span class="branch-no">{{ selectedShop.VAN_BIZ_NO }}</span>
      </div>
      <div class="header-right">
        <span class="branch-nm">{{ selectedShop.SHOP_NM }}</span>
      </div>
      <div>
        <button
          v-if="userInfo && userInfo.OGN_FG === '00'"
          class="next-shop-btn"
          @click="toggleAutoSwitch"
        >
          {{ isAutoSwitching ? "■" : "▶" }}
        </button>
      </div>
      <div class="filter-container">
        <div class="filter-top" v-if="this.userInfo?.OGN_FG == '00'">
          <label for="branches">
            <b>본부&nbsp;</b>
          </label>
          <select v-model="selectedBranch" @change="fetchBranchData">
            <option value="">전체</option>
            <option
              v-for="branch in branches"
              :key="branch.BRANCH_CD"
              :value="branch.BRANCH_CD"
            >
              {{ branch.BRANCH_NM }}
            </option>
          </select>
        </div>
        <div class="filter-bottom" v-if="this.userInfo?.OGN_FG == '00'">
          <b
            style="cursor: pointer"
            @dblclick="toggleIntervalInput"
            title="더블클릭하면 갱신주기를 변경할 수 있습니다."
          >
            매장&nbsp;
          </b>
          <input placeholder="검색" type="text" @input="onQuickFilterChanged" />
        </div>
        <div v-if="showIntervalInput" class="interval-input-container">
          초 입력
          <input
            v-if="showIntervalInput"
            type="number"
            v-model="customInterval"
            placeholder="초 입력"
          />
          <button v-if="showIntervalInput" @click="applyCustomInterval">
            적용
          </button>
        </div>
      </div>
    </header>

    <!-- 메인 콘텐츠와 우측 리스트 -->
    <div class="content">
      <!-- 우측 리스트 -->
      <aside
        class="ranking-table"
        style="float: right; min-width: 13.8rem; width: 21%"
        v-if="this.userInfo?.OGN_FG == '00'"
      >
        <ag-grid-vue
          class="ag-bs-balham"
          :style="{ width: '100%', height: gridHeight + 'rem' }"
          :theme="theme"
          :rowData="shopList"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :gridOptions="gridOptions"
          :rowSelection="rowSelection"
          :animateRows="true"
          @grid-ready="onGridReady"
          @cell-clicked="onCellClicked"
          :modules="gridModules"
          :suppressRowDrag="true"
        ></ag-grid-vue>
      </aside>
      <!-- 메인콘텐츠 -->
      <div class="stats">
        <div class="stat-item">
          <span class="label">당월 목표 :</span>
          <span class="value green">{{ selectedStats.SALE_GOAL }}</span>
          <span class="label">달성 점수 :</span>
          <span class="value green">{{ selectedStats.SALE_SCORE }}</span>
        </div>
        <div class="stat-item">
          <span class="label">당월 수량 :</span>
          <span class="value green">{{ selectedStats.SALE_QTY }}</span>
          <span class="label">예상 점수 :</span>
          <span class="value green">{{ selectedStats.EXP_SALE_SCORE }}</span>
        </div>
        <div class="stat-item">
          <span class="label">예상 수량 :</span>
          <span class="value green">{{ selectedStats.EXP_SALE_QTY }}</span>
          <span class="label">평균 점수 :</span>
          <span class="value green">{{ selectedStats.SALE_SCORE_AVG }}</span>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="header-cell">
              <span class="label-mango">예상달성률</span>
            </div>
            <div class="header-cell">
              <span class="label-mango">당일까지 누적 흑적자</span>
            </div>
          </div>
          <div class="table-body">
            <div class="body-cell">
              <span class="value large">{{ selectedStats.SALE_RATE }}%</span>
            </div>
            <div class="body-cell">
              <span
                class="value large"
                :style="{
                  color: selectedStats.profit >= 0 ? '#feb4f1' : '#00ffff',
                }"
              >
                {{ selectedStats.profitsum }}
              </span>
            </div>
          </div>
        </div>
        <div class="stat-item">
          <span class="owner">사업주명 :</span>
          <span class="owner">{{ selectedStats.OWNER_NM }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";

import {
  ClientSideRowModelModule,
  TextFilterModule,
  ModuleRegistry,
  QuickFilterModule,
  AllCommunityModule,
  ValidationModule,
  themeBalham,
} from "ag-grid-community";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  QuickFilterModule,
  AllCommunityModule,
  ValidationModule,
]);

export default {
  components: {
    AgGridVue,
  },
  data() {
    return {
      userInfo: null, // 로그인한 사용자 정보

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        borderColor: "#ddd",
        wrapperBorder: true,
        headerRowBorder: true,
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),
      branches: [], // 점포 목록
      shopList: [], // 선택된 점포의 데이터
      selectedBranch: "", // 선택된 BRANCH_CD
      selectedShop: {
        VAN_BIZ_NO: "", // 점번
        SHOP_NM: "", // 점명
      }, // 현재 선택된 점포 정보
      currentShopIndex: 0, // 현재 선택된 shopList의 인덱스
      autoSwitchInterval: null, // 자동 전환 타이머
      isAutoSwitching: true, // 자동 전환 상태
      customInterval: 5, // 기본 화면 전환 주기 (초)
      showIntervalInput: false, // 화면 전환 주기 입력창 표시 여부
      gridHeight: window.innerWidth > 1024 ? 45 : 36.5, // 그리드 높이
      columnDefs: [
        {
          headerName: "순서",
          valueGetter: "node.rowIndex + 1",
          width: 48,
          sortable: false,
        },
        {
          headerName: "점번",
          field: "VAN_BIZ_NO",
          width: 48,
        },
        {
          headerName: "점명",
          field: "SHOP_NM",
          flex: 1,
          width: 100,
        },
      ],
      defaultColDef: {
        resizable: false, // 셀 크기 조정 가능
        sortable: true, // 정렬 가능
      },
      gridOptions: {
        // enableSorting: true,
        // animateRows: true,
        quickFilterText: "",
        suppressDragLeaveHidesColumns: true, // 드래그 시 열 숨기기 방지
        getRowHeight: (params) => {
          // 특정 조건에 따라 다른 높이 반환
          if (params.node.rowPinned && params.data.height) {
            // 고정된 하단 행의 경우
            return params.data.height;
          }
          // 기본 행 높이
          return 20; // 이 값을 조절
        },
      },
      // 필요한 모듈 등록
      gridModules: [
        ClientSideRowModelModule,
        TextFilterModule,
        QuickFilterModule,
      ],
      gridApi: null, // gridApi 초기화
      rowSelection: { mode: "singleRow", checkboxes: false },
      // 메인 콘텐츠에 표시할 데이터
      selectedStats: {
        SALE_GOAL: 0,
        SALE_SCORE: 0,
        SALE_QTY: 0,
        EXP_SALE_SCORE: 0,
        EXP_SALE_QTY: 0,
        SALE_SCORE_AVG: 0,
        SALE_RATE: 0,
        profitsum: 0,
        OWNER_NM: "N/A",
        profit: 0,
      },
    };
  },
  created() {
    // 초기 데이터 로드
    const userInfoString = localStorage.getItem("userInfo"); 
    if (userInfoString) { 
      this.userInfo = JSON.parse(userInfoString); 
    } 
 
    const params = {};
    if (this.userInfo && this.userInfo.OGN_FG !== "00") {
      params.shopCd = this.userInfo.SHOP_CD;
    }
    axios
      // .get("/api/bsListPage")
      .get("/api/bsListPage", { params })
      .then((response) => {
        this.branches = response.data.branches || []; // 점포 목록
        this.shopList = response.data.shops || []; // 초기 점포 데이터
        if (this.shopList.length > 0) {
          this.setShopByIndex(0); // 첫 번째 점포로 초기화
        }

        // 본사/관리자 사용자일 경우에만 자동 전환 시작
        if (this.userInfo && this.userInfo.OGN_FG === "00") {
          this.startAutoSwitch(this.customInterval * 1000);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    this.stopAutoSwitch();
  },
  methods: {
    // 선택된 BRANCH_CD에 따라 데이터 가져오기
    fetchBranchData() {
      const branchCd = this.selectedBranch || ""; // 선택된 BRANCH_CD가 없으면 전체 조회
      axios
        .get("/api/bsListPage/branch", { params: { branchCd } })
        .then((response) => {
          this.shopList = [...response.data]; // 새로운 배열로 재할당
        })
        .catch((err) => {
          console.error(err);
          this.shopList = []; // 오류 발생 시 빈 배열로 초기화
        });
    },
    fetchDetails(shopCd) {
      // DB에서 추가 데이터 조회
      axios
        .get("/api/bsListPage/details", { params: { shopCd } })
        .then((response) => {
          const data = response.data;
          this.selectedStats = {
            SALE_GOAL: data.SALE_GOAL
              ? Math.round(data.SALE_GOAL).toLocaleString()
              : "0", // 정수로 변환
            SALE_SCORE: data.SALE_SCORE
              ? parseInt(data.SALE_SCORE).toLocaleString()
              : "0", // 실수로 변환
            SALE_QTY: data.SALE_QTY
              ? Math.round(data.SALE_QTY).toLocaleString()
              : "0", // 정수로 변환
            EXP_SALE_SCORE: data.EXP_SALE_SCORE
              ? parseInt(data.EXP_SALE_SCORE).toLocaleString()
              : "0", // 실수로 변환
            EXP_SALE_QTY: data.EXP_SALE_QTY
              ? Math.round(data.EXP_SALE_QTY).toLocaleString()
              : "0", // 정수로 변환
            SALE_SCORE_AVG: data.SALE_SCORE_AVG
              ? parseFloat(data.SALE_SCORE_AVG).toFixed(1).toLocaleString()
              : "0", // 실수로 변환
            SALE_RATE: data.SALE_RATE
              ? parseFloat(data.SALE_RATE).toFixed(0).toLocaleString()
              : "0", // 실수로 변환
            profitsum: data.profitsum
              ? parseInt(data.profitsum).toLocaleString()
              : "0", // 실수로 변환
            OWNER_NM: data.OWNER_NM || "N/A", // 문자열 그대로 사용
            profit: data.profit ? parseInt(data.profit).toLocaleString() : "0", // 실수로 변환
          };
        })
        .catch((err) => {
          console.error("Error fetching shop details:", err);
        });
    },
    onGridReady(params) {
      this.gridApi = params.api; // gridApi 초기화
      //   params.api.sizeColumnsToFit(); // 화면에 맞게 열 크기 조정
      //   window.addEventListener("resize", () => params.api.sizeColumnsToFit()); // 창 크기 변경 시 적용
    },
    handleResize() {
      const isWide = window.innerWidth > 1024;
      const newGridHeight = isWide ? 45 : 36.5;
      if (this.gridHeight !== newGridHeight) {
        this.gridHeight = newGridHeight;
      }
    },
    onCellClicked(event) {
      if (event.node) {
        event.node.setSelected(true); // 행(row)을 선택
        // console.log("Selected Row Data:", event.node.data); // 선택된 데이터 출력

        const selectedShop = event.node.data; // 선택된 행의 SHOP_CD 가져오기
        this.selectedShop = {
          VAN_BIZ_NO: selectedShop.VAN_BIZ_NO,
          SHOP_NM: selectedShop.SHOP_NM,
        };
        this.fetchDetails(selectedShop.SHOP_CD);
      }
    },
    onQuickFilterChanged(event) {
      const filterValue = event.target.value; // 입력 필드 값 가져오기
      if (this.gridApi) {
        this.gridApi.setGridOption("quickFilterText", filterValue); // quickFilter 적용
      } else {
        console.error("Grid API is not initialized.");
      }
    },
    setShopByIndex(index) {
      // 매장 사용자인 경우(OGN_FG === '01'), 자신의 매장 정보만 표시
      const shop = this.shopList[index];
      if (this.userInfo && this.userInfo.OGN_FG === "01") {
        if (this.shopList && this.shopList.length > 0) {
          console.log(this.shopList);
          this.selectedShop = {
            VAN_BIZ_NO: shop.VAN_BIZ_NO,
            SHOP_NM: shop.SHOP_NM,
          };
        }
        this.fetchDetails(this.userInfo.SHOP_CD);
        return;
      }

      if (index >= 0 && index < this.shopList.length) {
        this.selectedShop = {
          VAN_BIZ_NO: shop.VAN_BIZ_NO,
          SHOP_NM: shop.SHOP_NM,
        };
        this.currentShopIndex = index;
        this.fetchDetails(shop.SHOP_CD); // shop_cd로 데이터 갱신
      }
    },
    goToNextShop() {
      const nextIndex = (this.currentShopIndex + 1) % this.shopList.length; // 순환 이동
      this.setShopByIndex(nextIndex);
    },
    startAutoSwitch(interval) {
      this.stopAutoSwitch(); // 기존 타이머 정지
      this.autoSwitchInterval = setInterval(() => {
        this.goToNextShop(); // 다음 shop_cd로 이동
      }, interval);
      this.isAutoSwitching = true; // 자동 전환 활성화
    },
    // 자동 전환 정지
    stopAutoSwitch() {
      if (this.autoSwitchInterval) {
        clearInterval(this.autoSwitchInterval);
        this.autoSwitchInterval = null;
      }
      this.isAutoSwitching = false; // 자동 전환 비활성화
    },
    // 자동 전환 상태 토글
    toggleAutoSwitch() {
      if (this.isAutoSwitching) {
        this.stopAutoSwitch(); // 자동 전환 중지
      } else {
        this.startAutoSwitch(this.customInterval * 1000); // 자동 전환 시작
      }
    },
    applyCustomInterval() {
      const intervalMs = this.customInterval * 1000; // 초를 밀리초로 변환
      if (intervalMs > 0) {
        this.startAutoSwitch(intervalMs); // 새로운 주기로 자동 전환 시작
        this.showIntervalInput = false; // 입력창 숨기기
      } else {
        alert("1초 이상의 값을 입력하세요."); // 유효하지 않은 값 처리
      }
    },
    // 입력창 표시/숨기기 토글
    toggleIntervalInput() {
      this.showIntervalInput = !this.showIntervalInput; // 상태를 반전
    },
    beforeDestroy() {
      // 컴포넌트가 파괴되기 전에 자동 전환 정지
      this.stopAutoSwitch();
    },
  },
};
</script>

<style scoped>
.bsList-page {
  font-family: "맑은 고딕", "Arial Black", "Impact", sans-serif;
  font-weight: bold;
  color: white;
  background-color: black;
  padding: 1px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: red;
  color: white;
}

.bsList-page .header .header-left span:first-child {
  font-size: 3rem;
  padding-left: 30px;
}

.branch-no {
  font-family: "Arial Black", "Impact", sans-serif;
  text-align: left; /* 왼쪽 정렬 */
  color: white;
  font-size: 4.5rem;
}

.header-right {
  display: flex;
  justify-content: flex-end; /* 오른쪽 정렬 */
  align-items: center; /* 세로 가운데 정렬 */
  flex: 1; /* 남은 공간을 차지하여 오른쪽 끝으로 밀어냄 */
}

.branch-nm {
  font-family: "나눔 고딕", "Arial Black", "Impact", sans-serif; /* 숫자 폰트 */
  text-align: right; /* 오른쪽 정렬 */
  color: white;
  font-size: 4.5rem;
  font-weight: bold;
}

.filter-container {
  display: flex;
  flex-direction: column; /* 위아래로 배치 */
  gap: 15px; /* 위아래 간격 */
  margin: 10px; /* 전체 컨테이너 하단 여백 */
}

.filter-top {
  gap: 10px; /* Label과 Select 간격 */
}

.filter-top select {
  width: 10rem; /* Select 박스의 너비 */
  height: 2.5rem; /* Select 박스의 높이 */
  font-size: 1rem; /* 글자 크기 */
}

.filter-top label b,
.filter-bottom b {
  font-size: 1.2rem; /* 글자 크기 */
}

.filter-bottom {
  display: flex;
  align-items: center; /* 수직 정렬 */
}

.filter-bottom input {
  width: 9.5rem; /* Input 박스의 너비 */
  height: 2.13rem; /* Input 박스의 높이 */
  font-size: 1.2rem; /* 글자 크기 */
}

.filter-bottom b {
  cursor: pointer; /* 더블 클릭 가능하도록 커서 변경 */
}

.next-shop-btn {
  background-color: #ffcc00;
  color: black;
  border: #ffffff solid 3px;
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  margin-left: 5px;
}

.next-shop-btn:hover {
  background-color: #ffaa00;
}

.interval-input-container {
  display: flex;
  align-items: center; /* 수직 정렬 */
  gap: 5px; /* 인풋박스와 버튼 간 간격 */
}

.interval-input-container input {
  font-size: 1rem;
  width: 3rem; /* 인풋박스 너비 */
  cursor: pointer;
}

.interval-input-container button {
  font-size: 1rem;
  cursor: pointer;
}

/* 메인콘텐츠 css */
.stat-item {
  display: flex;
  align-items: center; /* 가운데 정렬 */
  justify-content: left; /* 세로 가운데 정렬 */
}

.label {
  font-family: "Noto Sans KR", "나눔고딕", "맑은 고딕", sans-serif; /* 한글 폰트 */
  font-size: 2.1rem;
  color: yellow;
  margin-left: 10px;
  font-weight: bold;
  flex-shrink: 0;
}
.value {
  font-family: "Arial Black", "Impact", sans-serif; /* 숫자 폰트 */

  flex: 1; /* 동일한 비율로 공간 차지 */
}

.value.green {
  font-size: 3.8rem;
  font-weight: bold;
  color: #00ff00;
  text-align: right; /* 오른쪽 정렬 */
}

.label-orange {
  color: orange;
  font-size: 2.8rem;
  font-weight: bold;
}

.label-mango {
  color: #ff8040;
  font-size: 2.4rem;
  font-weight: bold;
}

.value.pink {
  color: pink;
}

.value.large {
  font-size: 6.5rem; /* 폰트 크기 */
  font-weight: bold; /* 굵게 */
}

.table-container {
  display: flex;
  flex-direction: column; /* 위아래로 배치 */
  padding-top: 20px;
}

.table-header,
.table-body {
  display: flex;
  text-align: center; /* 텍스트 가운데 정렬 */
}

.header-cell,
.body-cell {
  flex: auto; /* 동일한 비율로 공간 차지 */
  text-align: center; /* 텍스트 가운데 정렬 */
}

.owner {
  font-size: 2.5rem;
  color: #ffffa2;
  font-weight: bold;
  margin-right: 10px;
  margin-left: 10px;
}
/* grid 헤더 스타일 */
:deep(.ag-bs-balham .ag-header-cell-text) {
  color: white;
}
/* grid 헤더 스타일 */
:deep(.ag-bs-balham .ag-header-cell) {
  border: 1px solid white; /* 헤더 셀 테두리 추가 */
  /* box-sizing: border-box; */
}

/* grid 데이터 셀 스타일 */
:deep(.ag-bs-balham .ag-cell) {
  font-size: 0.9rem;
  text-align: center !important;
  color: yellow;
  /* border: 0.5px solid #ddd; */
  background-color: black;
}
/* grid 헤더 배경색 */
:deep(.ag-bs-balham .ag-header-container) {
  /* 헤더 배경색 */
  background-color: red !important;
  /* background-color: #ffffff !important; 어두운 배경색 */
  /* 헤더 배경색 */
}
/* grid 헤더 텍스트 정렬 */
:deep(.ag-bs-balham .ag-header-cell-label) {
  justify-content: center !important;
  font-size: 0.9rem;
}

:deep(.ag-bs-balham .ag-row-hover .ag-cell) {
  /* putting in !important so it overrides the theme's styling as it hovers the row also */
  background-color: red; /* 적절히 어두운 배경색 */
  border: 1px solid #ffffff; /* 밝은 테두리 */
}

/* 화면 너비가 1024px 초과일 때 적용될 스타일 */
@media (min-width: 1025px) {
  .bsList-page .header .header-left span:first-child {
    font-size: 3.3rem; /* 기존 3rem */
  }

  /* 헤더 점번, 점명 */
  .bsList-page .header .header-left .branch-no,
  .bsList-page .header .header-right .branch-nm {
    font-size: 5rem; /* 기존 4.5rem */
  }
  .header-right {
    justify-content: center;
  }

  /* 다음 매장 버튼 */
  .bsList-page .header .next-shop-btn {
    font-size: 1.7rem; /* 기존 1.5rem */
  }

  /* 필터 컨테이너 */
  .bsList-page .header .filter-container .filter-top label b,
  .bsList-page .header .filter-container .filter-bottom b {
    font-size: 1.4rem; /* 기존 1.2rem (인라인 스타일) */
  }
  .bsList-page .header .filter-container .filter-top select {
    font-size: 1.2rem; /* 기존 1rem */
    height: 3rem; /* 기존 2.5rem에서 조정 */
  }
  .bsList-page .header .filter-container .filter-bottom input {
    font-size: 1.4rem; /* 기존 1.2rem */
    height: 2.5rem; /* 기존 2.1rem에서 조정 */
  }

  /* 갱신주기 입력란 */
  .bsList-page .header .filter-container .interval-input-container {
    font-size: 1.2rem; /* "초 입력" 텍스트 (기존 상속값) */
  }
  .bsList-page .header .filter-container .interval-input-container input,
  .bsList-page .header .filter-container .interval-input-container button {
    font-size: 1.2rem; /* 기존 1rem */
  }

  /* 메인 콘텐츠 통계 섹션 */
  .bsList-page .content .stats .stat-item .label {
    font-size: 3.1rem; /* 기존 2.1rem */
  }
  .bsList-page .content .stats .stat-item .value.green {
    font-size: 5.2rem; /* 기존 3.8rem */
    text-align: center;
  }
  .bsList-page
    .content
    .stats
    .table-container
    .table-header
    .header-cell
    .label-mango {
    font-size: 3.4rem; /* 기존 2.4rem */
  }
  .bsList-page
    .content
    .stats
    .table-container
    .table-body
    .body-cell
    .value.large {
    font-size: 7.5rem; /* 기존 6.5rem */
  }
  .bsList-page .content .stats .stat-item .owner {
    font-size: 3.2rem; /* 기존 2.5rem */
  }

  /* 우측 AG Grid (랭킹 테이블) */
  .bsList-page .content .ranking-table :deep(.ag-bs-balham .ag-cell) {
    font-size: 1rem; /* 기존 0.9rem */
  }
}
</style>
